import { Grid } from '@mantine/core'
import { NODE_STATUS_COLORS } from 'App/ServiceCenter/Map/_utils/getActiveNodeStatus'
import { TargetPest } from 'App/ServiceCenter/SelectedEquipmentCard/Shared/TargetPest/TargetPest'
import { serviceCenterStore } from 'App/ServiceCenter/store/serviceCenterStore'
import { ToggleSymbolValue } from 'App/ServiceCenter/ToggleSymbolValue/ToggleSymbolValue'
import type { TActiveNode, TDnNodeLog, TSnNodeLog } from 'App/ServiceCenter/types'
import { renderWithDefaultValue } from 'App/ServiceCenter/utils/renderers'
import { translate } from 'i18n/i18n'
import moment from 'moment-timezone'
import React from 'react'

export const TrapConfigDetail: React.FC<{ timezone: string }> = ({ timezone }) => {
  const selectedNode = serviceCenterStore.useSelector(serviceCenterStore.selectors.getSelectedEquipmentNode)

  const lastLog = serviceCenterStore.useSelector(serviceCenterStore.selectors.getSelectedEquipmentLastLog) as
    | TSnNodeLog
    | TDnNodeLog

  const selectedNodePrimaryLure = serviceCenterStore.useSelector(
    serviceCenterStore.selectors.getSelectedEquipmentPrimaryLure,
  )

  if (!selectedNode) return null

  const latestGoodPhoto = (selectedNode as TActiveNode)?.trap?.latestGoodPhoto?.takenOn
  const latestGoodPhotoLabel = latestGoodPhoto && moment.tz(latestGoodPhoto, timezone).fromNow()

  const getLatestServiceDate = () => {
    const { trap: trapConfig } = selectedNode as TActiveNode

    if (!trapConfig) return null

    const { lastService } = trapConfig

    if (!lastService) return null

    const results: {
      battery: string | null
      coroplast: string | null
      lure: string | null
      liner: string | null
    } = {
      battery: null,
      coroplast: null,
      lure: null,
      liner: null,
    }

    // check all consumables last updated date and return the latest
    lastService.batteryServicedLastOn && (results.battery = lastService.batteryServicedLastOn)

    lastService.coroplastServicedLastOn && (results.coroplast = lastService.coroplastServicedLastOn)

    lastService.lureServicedLastOn && (results.lure = lastService.lureServicedLastOn)

    lastService.linerServicedLastOn && (results.liner = lastService.linerServicedLastOn)

    let latestDate: string | null = null

    Object.values(results).forEach((date) => {
      if (!latestDate) latestDate = date

      if (date && latestDate && new Date(date) > new Date(latestDate)) latestDate = date
    })

    return latestDate
  }

  const latestServiceDate = getLatestServiceDate()

  return (
    <Grid css={{ fontSize: '14px', marginBottom: '8px' }}>
      <TargetPest />
      <Grid.Col span={4}>{translate.phrases.placeholder('Lure Type')}</Grid.Col>
      <Grid.Col span={8}>
        {selectedNodePrimaryLure
          ? translate.phrases.placeholder(selectedNodePrimaryLure.lureName)
          : translate.phrases.placeholder('-')}
      </Grid.Col>

      <Grid.Col span={4}>{translate.phrases.placeholder('Last Service')}</Grid.Col>
      <Grid.Col span={8}>
        {latestServiceDate ? (
          <ToggleSymbolValue value={moment.tz(latestServiceDate, timezone).format('lll z')}>
            {latestServiceDate ? moment.tz(latestServiceDate, 'UTC').fromNow() : '-'}
          </ToggleSymbolValue>
        ) : (
          translate.phrases.placeholder('-')
        )}
      </Grid.Col>

      <Grid.Col span={4}>{translate.phrases.placeholder('Last Good Photo')}</Grid.Col>
      <Grid.Col span={8}>
        {latestGoodPhoto ? (
          <span
            style={{
              color:
                latestGoodPhotoLabel?.includes('min') || latestGoodPhotoLabel?.includes('sec')
                  ? NODE_STATUS_COLORS.active
                  : 'black',
            }}
          >
            <ToggleSymbolValue value={moment.tz(latestGoodPhoto, timezone).format('lll z')}>
              {translate.phrases.placeholder(latestGoodPhotoLabel as string)}
            </ToggleSymbolValue>
          </span>
        ) : (
          translate.phrases.placeholder('-')
        )}
      </Grid.Col>

      <Grid.Col span={4}>{translate.phrases.placeholder('Image Count')}</Grid.Col>
      <Grid.Col span={8} css={{ fontWeight: 500 }}>
        {renderWithDefaultValue(lastLog?.imageCount)}
      </Grid.Col>
    </Grid>
  )
}
